import React from 'react'
import { Container } from 'react-bootstrap'
import './LandingComponent.css'
import { BiSearch } from 'react-icons/bi'
import TypewriterComponent from 'typewriter-effect'
import LandingStatistics from '../LandingStatistics/LandingStatistics'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
export default function LandingComponent() {
    const nav = useNavigate();
    let searchValue = '';
    function handel() {
        if (searchValue == '')
            return toast.warn('متن جست و جو نمیتواند خالی باشد')
        nav("/search/" + searchValue + "/all")
    }

    return (
        <div className='landing-component'>
            <Container className='landing-container'>
                <h1>
                    <TypewriterComponent
                        onInit={(typeWriter) => {
                            typeWriter
                                .typeString("آموزش آنلاین صنایع")
                                .start()
                                .pauseFor(2000)
                                .deleteAll()
                                .typeString('کسب مهارت برای اشتغال')
                                .start()
                                .pauseFor(2000)
                                .deleteAll()
                                .typeString('یادگیری از حرفه ای ها')
                                .start()
                                .pauseFor(2000)
                                .deleteAll()
                        }}
                        options={{
                            loop: true
                        }
                        }
                    />
                </h1>
                <h3>سازمان علمی و آموزشی <span className='brand-name'> سه نیک</span></h3>

                <div className='search-box'>
                    <input type="text" placeholder='جستجو کنید...' onChange={(e) => searchValue = e.target.value} />
                    <BiSearch onClick={handel} />
                </div>
                <div>
                    <LandingStatistics />
                </div>


            </Container>
        </div>
    )
}
